<div class="dropdown" (click)="toggle()">
    <div class="sort-btn-container d-flex align-items-center justify-content-between" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" #toggleButton>
        <span>
            {{ selectedOption()?.viewValue }}
        </span>
        <img src="/assets/images/down-arrow.svg" class="down-arrow-icon" [ngClass]="!collapsed ? 'arrow-up' : 'arrow-down'" />
    </div>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        @for (option of list; track option.value; let i = $index) {
        <li>
            <a class="dropdown-item" (click)="changeSelection(option?.value || '', i)">{{
        option?.viewValue
      }}</a>
        </li>
        }
    </ul>
</div>